import { FDealType } from '@/packages/JsonQuery';

import { type IOfferType } from '../../../types';

import { OFFER_TYPES_RENT_COMMERCIAL, OFFER_TYPES_SALE_COMMERCIAL } from './constants';

interface IParameters {
  dealType: FDealType;
}

export function getCommercialOfferTypeList({ dealType }: IParameters): IOfferType[][] {
  switch (dealType) {
    case FDealType.Sale:
      return OFFER_TYPES_SALE_COMMERCIAL;
    case FDealType.RentLongterm:
      return OFFER_TYPES_RENT_COMMERCIAL;
    default:
      return [];
  }
}
